import HtmlParser from 'html-react-parser';
import React from 'react';
import Helmet from 'react-helmet';
import ReactPlayer from 'react-player';
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import { DemoFormShort } from '../../components/DemoFormShort.jsx';
import JoinHappyCustomers from '../../components/JoinHappyCustomers';
import MultimedialPanel from '../../components/MultimedialPanel';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';

const Home = (props) => {

    const location = props.location;

    return (
        <Layout  bodyClass="page-integrations org-chart" ontouchstart>
            <SEO title="Org Chart | ChartHop | People Analytics, Visualized" />
            <Helmet>
                <meta
                    name="description"
                    content="Create and update your organizational chart in seconds by connecting your People systems into one central hub. Finally, understand your org like never before."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Org Chart | ChartHop | People Analytics, Visualized" />
                <meta property="og:description" content="Create and update your organizational chart in seconds by connecting your People systems into one central hub. Finally, understand your org like never before." />
                <meta property="og:image" content={`https://www.charthop.com/home/meta-org-chart.png`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Org Chart | ChartHop | People Analytics, Visualized" />
                <meta name="twitter:description" content="Create and update your organizational chart in seconds by connecting your People systems into one central hub. Finally, understand your org like never before." />
                <meta name="twitter:image" content={`https://www.charthop.com/home/meta-org-chart.png`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
            </Helmet>

            {/* HERO CONTENT */}
            <section className="intro container">
                <div className="row py-5 align-items-center">
                    <div className="col-md-6 p-xs-2 mb-3 mb-md-0 pr-md-2 pr-lg-4">
                        <h1>One org chart, all your people data</h1>
                        <p className="header-p pb-1 pt-1">Foster connections and build transparency in your workplace with a data-rich, automatically updated org chart</p>
                        <div className="splitText"><DemoFormShort source={"platform-org-chart-demo-header"} /></div>                        
                    </div>
                    <div className="reactPlayerContainer col-md-6 order-md-1 padding-top-video-three" >
						<ReactPlayer
							url="/videos/visualize-dei.mp4"
							playing
							loop
							muted
							playsinline
						/>
					</div>
                </div>
            </section>


            {/* Organizational Chart */}
            <section className="sectionSpacing flex-centeredColumn">
            <h2 className="text-center mt-0 sectionSpacing-Margin">Visualize your organization across any dimension</h2> 

            <div className="flex-centeredColumn contentBlock">
					<div className="svg-info ">
                    <div className="svg-info-card-3col">
							<img src={'/product/org-chart/visualize.svg'} alt="Visualize" />
							<h3>Visualize a data-rich org chart</h3>
							<p>Slice and dice your org chart by a number of data points such as tenure, team, performance rating, and much more.</p>
						</div>
                        <div className="svg-info-card-3col">
							<img src={'/product/org-chart/transparency.svg'} alt="Put a face to the name" />
							<h3>Export historical versions of your org chart</h3>
							<p>Export your entire org chart, just a department, or even a snapshot from two quarters ago for auditing or recordkeeping purposes.</p>
						</div>
						<div className="svg-info-card-3col">
							<img src={'/product/org-chart/work.svg'} alt="Time Saving" />
							<h3>Foster connections between coworkers</h3>
							<p>Share hobbies, interests, skills, and much more in an easily filterable employee directory.</p>
						</div>
                        {/*<div className="svg-info-card-3col">
							<img src={'/product/org-chart/transparency.svg'} alt="Transparency" />
							<h3>Increase transparency</h3>
							<p>Give employees the context they need to be productive and feel engaged.</p>
						</div>
                        <div className="svg-info-card-3col">
							<img src={} alt="Work" />
							<h3>Show how work gets done</h3>
							<p> Go beyond reporting structures. Visualize matrixed organizations, teams and more. </p>
						</div>
                       
                        <div className="svg-info-card-3col">
							<img src={'/product/org-chart/data.svg'} alt="Data Access" />
							<h3>Control data access</h3>
							<p> Ensure data remains secure with robust and customizable data controls. </p>
						</div>*/}
					</div>
				</div>

            </section>
            
            <section className="sectionSpacing backgroundGradientContainer" id="export">
				<div className="contentBlock">
                    <MultimedialPanel 
                        multimediaPosition="right"
                        title="Create a comprehensive, data-rich org chart that’s automatically updated from your other HR systems"
                        link="/product/2105-refresh/export-ppt.png"
                        type="image"
                        paddingClass="padding-top-video-two"
                        content={
                            <React.Fragment>
                                <p>
                                    See your entire organization with an org chart that is automatically updated from your payroll system and shows open roles from your ATS. Even include employees or contractors in the org chart that may not be in your payroll system.
                                </p>
                                <p>
                                    View the entire org reporting structure or filter to display by departments, teams, ethnicity, gender, performance, compensation, and much more.
                                </p>
                            </React.Fragment>
                        }
                    />
				</div>
			</section>

            <section className="sectionSpacing" id="travel">
				<div className="contentBlock">
                    <MultimedialPanel 
                        multimediaPosition="left"
                        title="Maintain and export visuals of your current and historical org charts"
                        link="/product/2105-refresh/org-chart-history.png"
                        type="image"
                        paddingClass="padding-top-video-three"
                        content={
                            <React.Fragment>
                                <p>
                                    Let everyone within the organization see the company’s org chart to understand reporting structures and roles. 
                                </p>
                                <p>
                                    Easily visualize the org chart at any point in time in your company’s history for board meetings or audit purposes, and directly export the org chart to PowerPoint slides as needed.
                                </p>
                            </React.Fragment>
                        }
                    />
				</div>
			</section>

            {/* plan */}
            <section className="sectionSpacing backgroundGradientContainer" id="plan">
				<div className="contentBlock">
                    <MultimedialPanel 
                        multimediaPosition="right"
                        title="Foster connections between coworkers with a map and employee directory"
                        link="/product/2105-refresh/connections.png"
                        type="images"
                        paddingClass="padding-top-video-three"
                        content={
                            <React.Fragment>
                                <p>
                                    Enrich employees’ understanding of one another with rich profiles that show personal interests, job descriptions, gender pronouns, name pronunciations, and more. You can also add dimension by capturing whatever you want employees to share with one another, from hobbies to favorite sports teams and more.
                                </p>
                                <p> 
                                    Enable nearby coworkers to connect with one another by viewing everyone on a city-level map.
                                </p>
                            </React.Fragment>
                        }
                    />
				</div>
			</section>

            <section className="sectionSpacing mx-0 mt-0">
                <h4 className="listTitle mt-0 text-center pt-3">The most powerful org chart available</h4>
                <div className="flex-checkbox-container">
                        <div className="checkmark-item">
                            <img src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
                            <p>Automatically updated org chart</p>
                        </div>
                        <div className="checkmark-item">
                            <img src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
                            <p>Employee directory</p>
                        </div>
                        <div className="checkmark-item">
                            <img src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
                            <p>Employee map</p>
                        </div>
                        <div className="checkmark-item">
                            <img src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
                            <p>Employee profiles</p>
                        </div>
                        <div className="checkmark-item">
                            <img src="/product-overview/icons/checkmark_icon.svg" alt="checkmark"/>
                            <p>Dynamic data-rich org chart</p>
                        </div>
                </div>
            </section>
            
            {/* AVAILABLE INTEGRATIONS */}
            <section className="backgroundGradientContainer-Reverse sectionSpacing flex-centeredColumn">
                <h2 className="text-center mt-0 sectionSpacing-Margin">Create and update your org chart automagically <span role="img" aria-label="sparkle">✨</span></h2> 
                <h4 className="text-center mt-0 sectionSpacing-Margin">Seamlessly integrate your HRIS or Payroll provider - no manual uploads required</h4>
                <div className="moreIntegrationsContent">
                    <div className="floating-minorCardContainer">

                        {/* FIRST 4 */}
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-bamboo@2x.jpg' alt="BambooHR" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-slack@2x.jpg' alt="Slack"/>
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-workday@2x.jpg' alt="Workday" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-successfactors@2x.jpg' alt="Success Factors" />
                            </div>
                        </div>

                        {/* SECOND 4 */}  
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-greenhouse@2x.jpg' alt="Greenhouse" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-lever@2x.jpg' alt="Lever" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-carta@2x.jpg' alt="Carta" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-e-trade@2x.jpg' alt="E-Trade" />
                            </div>
                        </div>

                        {/* THIRD 4 */}
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-trinet@2x.jpg' alt="Trinet" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/gusto.png' alt="Gusto" /> 
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-google.jpg' alt="Google" /> 
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-justworks@2x.jpg' alt="Justworks" />
                            </div>
                        </div>

                        {/* FOURTH 4 */}
                        <div>
                            <div>
                                <img src='/integrations/logos/sequoia.png' alt="Sequoia" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-paylocity@2x.jpg' alt="Paylocity" />
                            </div>
                        </div>
                        
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-namely@2x.jpg' alt="Namely" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/zenefits.png' alt="Zenefits" />
                            </div>
                        </div> 

                        {/* PSUEDO */}
                        <div className="psudeo ps1">
                        </div>

                        <div className="psudeo ps2">
                        </div>

                        <div className="psudeo ps3">
                        </div>

                        <div className="psudeo ps4">
                        </div>

                        {/* MORE */}
                        <h4 className="text-center">& more</h4>
                    </div>
                </div>
            </section>
            

            {/* LONG FORM */}
            <section name="request-demo " id="request-demo" className="request-demo pt-3 pb-4 pt-md-8 pb-md-8">
				<DemoFormLong source={"platform-org-chart-demo-bottom"} centerContent={true} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class=" mb-3 contact-testimonial">“Being able to visualize the org chart by any dimension (department, time zone, gender, squad) has empowered my team to make more strategic people decisions. </p><p class="contact-testimonial">ChartHop has helped us create a more transparent organization and helped employees forge deeper relationships with their coworkers.”</p><div class="authorTag"><img src="/home/quotes/quote_ShelbyWolpa@2x.jpg" class="testimonialAuthor" alt="Shelby Wolpa" /><div><p class="contactAuthor"><strong>Shelby Wolpa</strong> <br>VP, People Operations, Invision</p></div></div>')}/>
			</section>
        </Layout>
    );
};


export default Home;
